import * as React from "react";
import {
    PlasmicNavbar,
    DefaultNavbarProps
} from "./plasmic/main/PlasmicNavbar";
import {useState} from "react";
import netlifyIdentity from 'netlify-identity-widget'
import {useLinkClickHandler} from "react-router-dom";


export interface NavbarProps extends DefaultNavbarProps {
}


function Navbar({...rest}: NavbarProps) {
    const [user, setUser] = useState(netlifyIdentity.currentUser());
    netlifyIdentity.on('login', setUser);
    netlifyIdentity.on('logout', () => {
        setUser(null);
    });

    return (
        <PlasmicNavbar
            header={{
                onClick: useLinkClickHandler(`/`)
            }}
            state={user ? "loggedIn" : "loggedOut"}
            requestFeatures={{
                onClick: () => window.open('https://bimmy.canny.io', '_blank')
            }}
            logOut={{
                onClick: () => netlifyIdentity.logout()
            }}
            logIn={{
                onClick: () => netlifyIdentity.open('login')
            }}
            signUp={{
                onClick: () => netlifyIdentity.open('signup')
            }}
            {...rest}
        >
            {user?.user_metadata?.full_name?.charAt(0).toUpperCase()}
        </PlasmicNavbar>
    );
}

export default Navbar;
